import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { Link } from 'foundations-components/transitional/components/Link';
import LearnMoreModal from '../base/LearnMoreModal';
import { useIsFreeTier } from 'setup-guide-api/hooks/productLevels';
import { ONBOARDING_VIEWS } from 'onboarding-settings-client/constants/onboardingViews';
import { useModalTracker } from '../../../hooks/tracking';
import { ACADEMY_LESSON_IMPLEMENT_SALES_PROCESS_URL, KNOWLEDGE_BASE_AUTOMATE_DEALS_ARTICLE_URL, KNOWLEDGE_BASE_SETUP_PIPELINE_AND_DEAL_URL } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CustomizeDealStagesModal = ({
  onClose
}) => {
  const isFree = useIsFreeTier(ONBOARDING_VIEWS.SALES);
  const {
    trackLink
  } = useModalTracker('CustomizeDealStagesModal');
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.customizeDealStages.heading"
    }),
    illustrationName: "deals",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.customizeDealStages.description"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link
        },
        message: `setup-guide-components.modal.customizeDealStages.${isFree ? 'p1_freeUser_jsx' : 'p1_jsx'}`,
        options: {
          external: true,
          href: KNOWLEDGE_BASE_AUTOMATE_DEALS_ARTICLE_URL,
          onClick: () => trackLink('automate deals article')
        }
      })
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: KNOWLEDGE_BASE_SETUP_PIPELINE_AND_DEAL_URL,
      onClick: () => trackLink('setup pipeline and deal article'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: ACADEMY_LESSON_IMPLEMENT_SALES_PROCESS_URL,
      onClick: () => trackLink('setup implement sales process'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.watchVideo"
      })
    })]
  });
};
CustomizeDealStagesModal.propTypes = {
  onClose: PropTypes.func
};
export default CustomizeDealStagesModal;